import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Discount } from 'src/app/models/discount';
import { PosChangePriceModalComponent } from 'src/app/shared/pos-change-price-modal/pos-change-price-modal.component';
import { ModalDialogType } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class PosChangePriceModalService {
  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) {


  }

  async show(price: Number, confirmAction: (price: Number) => any): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.modalRef = this.modalService.show(PosChangePriceModalComponent, {
        ignoreBackdropClick: true
      });
      this.modalRef.setClass(`modal-dialog ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.price = price;
      this.modalRef.content.load();
      this.modalRef.content.confirmAction = confirmAction;

      resolve(true);
    })
  }
}
